<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-modal id="modal-upload" title="آپلود مدیا" centered ok-only ok-title="بستن">
      <b-form>
        <b-button class="mt-2 col-12 col-md-4" variant="warning" @click="$refs.refInputEl3.click()">
          <input ref="refInputEl3" type="file" class="d-none" @change="select">
          <span class="">بارگذاری</span>
        </b-button>
        <b-button variant="primary" class="mt-2 mb-sm-0 ml-2 col-12 col-md-2"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="uploadSubMedia">
          ثبت
        </b-button>
      </b-form>
      <b-progress v-if="uploaded2 !== 0 && uploaded2 !== 100" :value="uploaded2" max="100" variant="primary"
        class=" mt-2" />

      <b-alert :show="done === true" variant="success" class="col-12">
        <div class="alert-body mt-2">
          <feather-icon class="mr-25" icon="CheckIcon" />
          <span class="ml-25">فایل شما آپلود شده است.</span>
        </div>
      </b-alert>
      <b-alert :show="errorAlert" variant="danger" class="col-12">
        <div class="alert-body mt-2">
          <feather-icon class="mr-25" icon="CloseIcon" />
          <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
        </div>
      </b-alert>
    </b-modal>

    <div v-if="medias">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-form>
              <b-row>
                <!-- Field: fileData -->
                <b-col cols="12">
                  <h2>بارگذاری مدیای جدید</h2>

                  <b-button :disabled="isBtnsDisabled" class="mt-2 col-12 col-md-4" variant="warning"
                    @click="$refs.refInputEl2.click()">
                    <input ref="refInputEl2" type="file" class="d-none" @change="select">
                    <span class="">بارگذاری</span>
                    {{ file ? file.name : "" }}
                  </b-button>
                  <b-button :disabled="isBtnsDisabled" variant="primary" class="mt-2 mb-sm-0 ml-2   col-12 col-md-2"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="handleUpload">
                    ثبت
                  </b-button>
                  <b-row class="mt-2">
                    <b-col cols="">
                      تعداد چانک‌ها: {{ totalChunks }}
                    </b-col>
                    <b-col cols="">
                      <span>حجم آپلود شده: </span>
                      <span>{{ formatFileSize(uploadedBytes) }} </span>
                      از
                      <span>{{ formatFileSize(totalSize) }} </span>
                    </b-col>
                    <b-col cols="">
                      آخرین چانک آپلود شده:
                      {{ lastUploadedChunk }}
                    </b-col>
                    <b-col cols="">
                      سرعت: {{ formatFileSize(speedSpan) }} /s
                    </b-col>
                    <b-col cols="">
                      زمان تخمینی باقی‌مانده: {{ formatTime(etaSpan) }}
                    </b-col>

                  </b-row>
                  <b-alert :show="true" variant="warning" class="col-md-6 col-12">
                    <div class="alert-body mt-2">
                      <feather-icon class="mr-25" icon="CheckIcon" />
                      <span class="ml-25">توجه : اگر مدیای مورد نظر شما برای آپلود ویدیو میباشد به صورت پیشفرض با کیفیت
                        1080 ثبت میشود.</span>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
            </b-form>

            <b-progress v-if="uploaded2 !== 0 && uploaded2 !== 100" :value="uploaded2" max="100" variant="primary"
              class=" mt-2" />

            <b-alert :show="done === true" variant="success" class="col-md-2 col-12">
              <div class="alert-body mt-2">
                <feather-icon class="mr-25" icon="CheckIcon" />
                <span class="ml-25">فایل شما آپلود شده است.</span>
              </div>
            </b-alert>
            <b-alert :show="errorAlert" variant="danger" class="col-md-2 col-12">
              <div class="alert-body mt-2">
                <feather-icon class="mr-25" icon="CloseIcon" />
                <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
              </div>
            </b-alert>
          </b-card>

          <div v-if="productType == 2 || productType == 5 || productType == 8 || productType == 9" class="w-100">
            <b-card v-if="medias.videos.length > 0">
              <b-row class="px-2">

                <h3>ویدیو</h3>

                <div class="row mt-5">
                  <video preload="none" class="col-12" controls style="max-height: 30rem;">
                    <source size="" :src="`${baseURL}media/file/video/` + medias.videos[0].pictureUrl" type="" />
                  </video>
                  <b-button class="m-2" variant="danger" v-b-modal.modal-delete
                    @click="showModal(medias.videos[0].pictureUrl)">
                    <feather-icon icon="TrashIcon" size="20" class="" />
                  </b-button>

                  <b-button class="m-2" variant="primary"
                    @click="showChangeNameModal(medias.videos[0].mediaId, medias.videos[0].title.split('.')[0])"
                    v-b-modal.modal-edit-name>
                    <feather-icon icon="EditIcon" size="20" />
                  </b-button>

                  <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority
                    @click="showChangePriorityModal(medias.videos[0].mediaId, medias.videos[0].priority)">
                    <feather-icon icon="AlignCenterIcon" size="20" />
                  </b-button>
                </div>

              </b-row>
            </b-card>
            <b-card v-if="productType == 8">
              <b-col cols="12">
                <b-form-group class="mb-2" label="توضیحات" label-for="product-content">
                  <ckEditorMain ref="editorContent" @getEditorContent="setEditorContent"
                    :defaultContent="testDescription"></ckEditorMain>
                </b-form-group>
                <b-button class="m-2" variant="primary" @click="setTestDescription()">
                  ویرایش
                </b-button>
              </b-col>
            </b-card>
          </div>

          <div v-if="productType == 1 || productType == 3 || productType == 4 || productType == 6">
            <section v-if="medias.videos.length > 0" id="card-navigation">
              <b-row v-for="(video, item) in medias.videos">
                <!-- pill tabs inside card -->
                <b-col v-if="video.parentId === 0 || video.parentId === null" md="12">
                  <b-card class="text-center">
                    <b-tabs pills nav-class="mb-3">
                      <b-tab title="1080" active>
                        <app-collapse accordion class="col-12">
                          <app-collapse-item :title="video.title.split('.')[0]">
                            <video preload="none" class="col-12" controls style="max-height: 30rem;">
                              <source size="" :src="`${baseURL}media/file/video/` + video.pictureUrl" type="" />
                            </video>

                            <b-button v-if="video.arvanCloudVideoId === null" class="m-2" variant="info"
                              @click="arvanObj.mediaId = video.mediaId" v-b-modal.modal-arvan>
                              <feather-icon icon="UnlockIcon" size="20" class="" />
                            </b-button>

                            <b-button v-else class="m-2" variant="info">
                              <span v-if="video.aravanStatus === 'queue_download'">در صف دانلود ابرآروان</span>
                              <span v-if="video.aravanStatus === 'queue_convert'">در صف تبدیل</span>
                              <span v-if="video.aravanStatus === 'converting'">در حال تبدیل</span>
                              <span @click="arvanObj.mediaId = video.mediaId" v-b-modal.modal-arvan
                                v-if="video.aravanStatus && video.aravanStatus.toLowerCase && video.aravanStatus.toLowerCase().includes('fail')">
                                <feather-icon icon="UnlockIcon" size="20" class="" />
                                آپلود با مشکل مواجه شده دوباره تلاش کنید
                              </span>
                              <span v-if="video.aravanStatus === 'complete'">
                                <feather-icon icon="LockIcon" size="20" class="" />
                                <span class="ml-1">محافظت شده</span>
                              </span>
                            </b-button>

                            <b-button class="m-2" variant="danger" v-b-modal.modal-video-delete
                              @click="tempVideoObject = video">
                              <feather-icon icon="TrashIcon" size="20" class="" />
                            </b-button>

                            <b-button class="m-2" variant="primary"
                              @click="showChangeNameModal(video.mediaId, video.title.split('.')[0])"
                              v-b-modal.modal-edit-name>
                              <feather-icon icon="EditIcon" size="20" />
                            </b-button>

                            <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority
                              @click="showChangePriorityModal(video.mediaId, video.priority)">
                              <feather-icon icon="AlignCenterIcon" size="20" />
                            </b-button>

                            <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type
                              @click="selectMediaForMediaGroup(video.mediaId, video.mediaGroupType)">
                              <feather-icon icon="BookOpenIcon" size="20" />
                            </b-button>

                            <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable
                              @click="selectMediaForIsReachable(video.mediaId, video.isReachable)">
                              <feather-icon icon="SlashIcon" size="20" />
                            </b-button>
                          </app-collapse-item>
                        </app-collapse>
                      </b-tab>

                      <b-tab title="720">
                        <template v-for="mv in medias.videos">
                          <app-collapse v-if="mv.parentId === video.mediaId && mv.quality === 2" accordion
                            class="col-12">
                            <app-collapse-item :title="mv.title.split('.')[0]">
                              <video preload="none" class="col-12" controls style="max-height: 30rem;">
                                <source size="" :src="baseURL + 'media/file/video/' + mv.pictureUrl" type="" />
                              </video>
                              <b-button class="m-2" variant="danger" v-b-modal.modal-delete
                                @click="showModal(mv.pictureUrl)">
                                <feather-icon icon="TrashIcon" size="20" class="" />
                              </b-button>

                              <b-button class="m-2" variant="primary"
                                @click="showChangeNameModal(mv.mediaId, mv.title.split('.')[0])"
                                v-b-modal.modal-edit-name>
                                <feather-icon icon="EditIcon" size="20" />
                              </b-button>

                              <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority
                                @click="showChangePriorityModal(mv.mediaId, mv.priority)">
                                <feather-icon icon="AlignCenterIcon" size="20" />
                              </b-button>

                              <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type
                                @click="selectMediaForMediaGroup(mv.mediaId, mv.mediaGroupType)">
                                <feather-icon icon="BookOpenIcon" size="20" />
                              </b-button>

                              <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable
                                @click="selectMediaForIsReachable(mv.video.mediaId, mv.video.isReachable)">
                                <feather-icon icon="SlashIcon" size="20" />
                              </b-button>
                            </app-collapse-item>
                          </app-collapse>
                        </template>

                        <b-button class="m-2" variant="warning" v-b-modal.modal-upload
                          @click="setUploadParentId(video.mediaId, 2)">
                          آپلود ویدیو (کیفیت 720)
                        </b-button>
                      </b-tab>

                      <b-tab title="480">
                        <template v-for="mv in medias.videos">
                          <app-collapse v-if="mv.parentId === video.mediaId && mv.quality === 3" accordion
                            class="col-12">
                            <app-collapse-item :title="mv.title.split('.')[0]">
                              <video preload="none" class="col-12" controls style="max-height: 30rem;">
                                <source size="" :src="baseURL + 'media/file/video/' + mv.pictureUrl" type="" />
                              </video>
                              <b-button class="m-2" variant="danger" v-b-modal.modal-delete
                                @click="showModal(mv.pictureUrl)">
                                <feather-icon icon="TrashIcon" size="20" class="" />
                              </b-button>

                              <b-button class="m-2" variant="primary"
                                @click="showChangeNameModal(mv.mediaId, mv.title.split('.')[0])"
                                v-b-modal.modal-edit-name>
                                <feather-icon icon="EditIcon" size="20" />
                              </b-button>

                              <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority
                                @click="showChangePriorityModal(mv.mediaId, mv.priority)">
                                <feather-icon icon="AlignCenterIcon" size="20" />
                              </b-button>

                              <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type
                                @click="selectMediaForMediaGroup(mv.mediaId, mv.mediaGroupType)">
                                <feather-icon icon="BookOpenIcon" size="20" />
                              </b-button>

                              <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable
                                @click="selectMediaForIsReachable(mv.video.mediaId, mv.video.isReachable)">
                                <feather-icon icon="SlashIcon" size="20" />
                              </b-button>
                            </app-collapse-item>
                          </app-collapse>
                        </template>
                        <b-button class="m-2" variant="warning" v-b-modal.modal-upload
                          @click="setUploadParentId(video.mediaId, 3)">
                          آپلود ویدیو (کیفیت 480)
                        </b-button>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-col>
              </b-row>
            </section>

            <b-card v-if="medias.podcasts.length > 0">
              <b-row class="px-2">

                <h3>پادکست ها</h3>
                <app-collapse accordion class="col-12">

                  <app-collapse-item v-for="(podcast, item) in medias.podcasts" :title="podcast.title.split('.')[0]">
                    <audio class="col-12" preload="none" controls crossorigin playsinline>
                      <source :src="baseURL + 'media/file/podcast/' + podcast.pictureUrl" type="" />
                    </audio>
                    <b-button class="m-2" variant="danger" v-b-modal.modal-delete
                      @click="showModal(podcast.pictureUrl)">
                      <feather-icon icon="TrashIcon" size="20" class="" />
                    </b-button>

                    <b-button class="m-2" variant="primary"
                      @click="showChangeNameModal(podcast.mediaId, podcast.title.split('.')[0])"
                      v-b-modal.modal-edit-name>
                      <feather-icon icon="EditIcon" size="20" />
                    </b-button>

                    <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority
                      @click="showChangePriorityModal(podcast.mediaId, podcast.priority)">
                      <feather-icon icon="AlignCenterIcon" size="20" />
                    </b-button>

                    <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type
                      @click="selectMediaForMediaGroup(podcast.mediaId, podcast.mediaGroupType)">
                      <feather-icon icon="BookOpenIcon" size="20" />
                    </b-button>

                    <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable
                      @click="selectMediaForIsReachable(podcast.mediaId, podcast.isReachable)">
                      <feather-icon icon="SlashIcon" size="20" />
                    </b-button>
                  </app-collapse-item>

                </app-collapse>

              </b-row>
            </b-card>

            <b-card v-if="medias.images.length > 0">
              <b-row class="px-2">

                <h3>عکس ها</h3>
                <app-collapse accordion class="col-12">

                  <div class="row ">

                    <div v-for="(image, index) in medias.images" class="col-md-4 mt-3">

                      <img class="col-12" style="height: 400px"
                        :src="baseURL + 'media/file/picture/' + image.pictureUrl" alt="profile">
                      <b-button class="col-4 m-2" variant="danger" v-b-modal.modal-delete
                        @click="showModal(image.pictureUrl)">
                        <feather-icon icon="TrashIcon" size="20" class="" />
                      </b-button>

                      <b-button class="col-4 m-2" variant="success" v-b-modal.modal-edit-priority
                        @click="showChangePriorityModal(image.mediaId, image.priority)">
                        <feather-icon icon="AlignCenterIcon" size="20" />
                      </b-button>

                      <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type
                        @click="selectMediaForMediaGroup(image.mediaId, image.mediaGroupType)">
                        <feather-icon icon="BookOpenIcon" size="20" />
                      </b-button>

                      <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable
                        @click="selectMediaForIsReachable(image.mediaId, image.isReachable)">
                        <feather-icon icon="SlashIcon" size="20" />
                      </b-button>
                    </div>
                  </div>
                </app-collapse>
              </b-row>
            </b-card>

            <b-card v-if="medias.pdFs.length > 0">
              <b-row class="px-2">

                <h3>فایل ها</h3>
                <div v-for="(file, index) in medias.pdFs" class="col-12">

                  <div class="row ">
                    <div class="col-md-4 mt-3">

                      <a class="d-block" :href="baseURL + 'media/file/pdf/' + file.pictureUrl" download
                        target="_blank">{{
                          file.title.split('.')[0] }}</a>

                      <b-button class="" variant="danger" v-b-modal.modal-delete @click="showModal(file.pictureUrl)">
                        <feather-icon icon="TrashIcon" size="20" class="" />
                      </b-button>

                      <b-button class="m-2" variant="primary"
                        @click="showChangeNameModal(file.mediaId, file.title.split('.')[0])" v-b-modal.modal-edit-name>
                        <feather-icon icon="EditIcon" size="20" />
                      </b-button>

                      <b-button class="" variant="success" v-b-modal.modal-edit-priority
                        @click="showChangePriorityModal(file.mediaId, file.priority)">
                        <feather-icon icon="AlignCenterIcon" size="20" />
                      </b-button>

                      <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type
                        @click="selectMediaForMediaGroup(file.mediaId, file.mediaGroupType)">
                        <feather-icon icon="BookOpenIcon" size="20" />
                      </b-button>

                      <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable
                        @click="selectMediaForIsReachable(file.mediaId, file.isReachable)">
                        <feather-icon icon="SlashIcon" size="20" />
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modal-delete" centered ok-title="حذف" cancelTitle="انصراف" @ok="deleteMedia(deleteItem)">
      <span>حذف شود؟</span>
    </b-modal>
    <b-modal id="modal-edit-name" title="ویرایش نام فایل" centered ok-title="ثبت" cancelTitle="انصراف"
      @ok="updateMediaName">
      <input @keydown.enter="updateMediaName" type="text" v-model="newName">
    </b-modal>
    <b-modal id="modal-edit-priority" title="ویرایش اولویت فایل" centered ok-title="ثبت" cancelTitle="انصراف"
      @ok="updateMediaPriority">
      <input @keydown.enter="updateMediaPriority" type="number" v-model="newPriority">
    </b-modal>
    <b-modal id="modal-edit-type" title="ویرایش دسته بندی فایل" centered ok-title="ثبت" cancelTitle="انصراف"
      no-close-on-backdrop @ok="updateMediaGroupType">
      <b-row>
        <b-col cols="12">
          <span>دسته بندی ها :</span>
          <b-form-group label-cols="12">
            <v-select class="mt-1" v-model="selectedTypeForMediaGroup" :clearable="false" label="option"
              :options="mediaGroupTypes" :reduce="option => option.value" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-arvan" title="محافظت از فایل" centered ok-title="ثبت" cancelTitle="انصراف" @ok="arvanCreate">
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-row>
          <span class="mx-1 mb-1">عنوان :</span>
          <b-col cols="12">
            <validation-provider name="title" rules="required">
              <b-form-input id="title" v-model="arvanObj.title" class="form-control"></b-form-input>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-edit-isReachable" title="ویرایش دسترسی کاربران به فایل" centered ok-title="ثبت"
      cancelTitle="انصراف" no-close-on-backdrop @ok="setReachableMedia">
      <b-row>
        <b-col cols="12">
          <span>انتخاب دسترسی :</span>
          <b-form-group label-cols="12">
            <v-select class="mt-1" v-model="selectedIsReachableType" :clearable="false" label="option"
              :options="ReachableTypes" :reduce="option => option.value" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-video-delete" centered ok-title="حذف" cancelTitle="انصراف" @ok="sendMediaRemoveRequest()">
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BModal,
  BOverlay,
  BProgress,
  BRow,
  BTab,
  BTabs
} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from "vue-select";
import axios from "axios";
import { getUserData } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  MediaDeleteByPictureUrlRequest,
  ProductGetProductsMediasForAdminRequest,
  ProductSetMediaGroupTypeRequest,
  ProductSetReachableRequest,
  PsychologicalTestGetByProductId,
  UpdateResultDescription
} from "@/libs/Api/Product";
import { MediaChangeMediaNameRequest, MediaChangePriorityRequest } from "@/libs/Api/Media";
import Helper from "@/libs/Helper";
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { ArvanCloudVideoCreateRequest, DeleteArvanVideo } from "@/libs/Api/ArvanCloud";
import ckEditorMain from "@/views/components/ckEditorMain.vue";

export default {
  title: 'مدیای محصول - پنل ادمین ذهن آرایی',
  name: "ECommerceAddProductMediaWithChunk",
  components: {
    ckEditorMain,
    BCard,
    BRow,
    BCol,
    BButton,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BProgress,
    BModal,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      userToken: getUserData().token,
      medias: null,
      errorAlert: false,
      done: null,
      overlay: true,
      deleteItem: null,
      baseURL: Helper.baseUrl,
      types: [
        { name: 'دوره', value: 1 },
        { name: 'لایو', value: 2 },
        { name: 'فایل', value: 3 },
        { name: 'پادکست', value: 4 },
        { name: 'پست آموزشی', value: 5 },
        { name: 'استوری', value: 9 },
      ],
      file: null,
      chunks: [],
      uploaded: 0,
      uploaded2: 0,
      namePictureURL: null,
      priorityPictureURL: null,
      newName: '',
      newPriority: '',
      uploadParentId: null,
      quality: null,
      selectedMediaIdForMediaGroup: null,
      selectedTypeForMediaGroup: null,
      tempVideoObject: null,
      temptest: null,
      mediaGroupTypes: [
        { option: 'ویدئو', value: 1 },
        { option: 'تصویر جلسات', value: 4 },
        { option: 'پادکست', value: 6 },
        { option: 'فایل', value: 9 },
      ],
      arvanObj: {
        title: '',
        description: '',
        mediaId: null
      },
      selectedIsReachableType: null,
      testDescription: '',
      selectedMediaIdForIsReachableType: null,
      ReachableTypes: [
        { option: 'قابل دسترسی', value: true },
        { option: 'غیر قابل دسترسی', value: false },
      ],
      uploadInProgress: false,
      chunkSize: 10 * 1024 * 1024,
      currentChunkSpan: 0,
      fileId: 0,
      uploadStats: {
        startTime: null,
        chunksCompleted: 0,
        totalBytes: 0,
        speed: 0,
        estimatedTime: 0
      },
      totalChunks: 0,
      lastUploadedChunk: 0,
      uploadedBytes: 0,
      speedSpan: 0,
      etaSpan: 0,
      totalSize: 0,
      isBtnsDisabled: false
    };
  },
  computed: {
    productId() {
      console.log(12)
      return this.$route.params.id || this.$route.path.split('/')[4]
    },
    productType() {
      console.log(13)
      return this.$route.query.productType || this.$route.path.split('/')[5]
    }
  },
  watch: {
    async productId(newVal, oldVal) {
      if (newVal !== oldVal) await this.getProductMedias()
    }
  },
  async created() {
    await this.getProductMedias();
    if (this.productType == 8) {
      await this.getTestDescription();
    }
  },
  methods: {
    notify(variant, text, { title, icon } = {}) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title: title ?? (variant === 'success' ? 'عملیات موفق' : 'عملیات ناموفق'),
          icon: icon ?? (variant === 'success' ? 'CheckIcon' : 'CloseIcon'),
          variant,
          text,
        },
      })
    },
    addLog(msg, type = 'info') {
      const color = type === 'error' ? 'red' : type === 'success' ? 'green' : type === 'warning' ? 'yellow' : 'green'
      console.log(`%c ${msg}`, `color: ${color}`)
    },
    generateFileId() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatTime(seconds) {
      if (seconds < 60) return `${Math.round(seconds)} ثانیه`;
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.round(seconds % 60);
      return `${minutes} دقیقه و ${remainingSeconds} ثانیه`;
    },

    async handleUpload(resume = false) {
      if (!this.file) {
        this.notify('danger', 'لطفاً فایل انتخاب کنید', { icon: 'CheckIcon' })
        return;
      }

      if (this.chunkSize <= 0) {
        this.notify('danger', 'حجم chunk باید بزرگتر از صفر', { icon: 'CheckIcon' })
        return;
      }

      if (this.uploadInProgress) {
        this.addLog('آپلود در حال انجام است', 'warning')
        return;
      }

      this.totalSize = this.file.size;

      this.uploadStats = {
        startTime: new Date(),
        chunksCompleted: 0,
        totalBytes: this.file.size,
        speed: 0,
        estimatedTime: 0
      };
      if (!resume || !this.fileId) this.fileId = this.generateFileId();

      this.totalChunks = Math.ceil(this.file.size / this.chunkSize);
      let startChunk = resume ? this.lastUploadedChunk + 1 : 0;

      this.addLog(`شروع آپلود ${resume ? 'ادامه ' : ''}فایل: ${this.file.name}`, 'info')
      this.addLog(`حجم فایل: ${this.formatFileSize(this.file.size)}`, 'info');
      this.addLog(`تعداد chunks: ${this.totalChunks}`, 'info');
      this.addLog(`حجم هر chunk: ${this.formatFileSize(this.chunkSize)}`, 'info');
      this.addLog(`شروع از chunk: ${startChunk + 1}`, 'info');

      for (let i = 0; i < this.totalChunks; i++) {
        const start = i * this.chunkSize;
        const end = Math.min(start + this.chunkSize, this.file.size);
        const chunk = this.file.slice(start, end);

        this.currentChunkSpan = i + 1

        try {
          const chunkStartTime = new Date();

          await this.uploadChunk(i, this.totalChunks, chunk, this.file.name)

          const chunkTime = (new Date() - chunkStartTime) / 1000;
          const chunkSpeed = chunk.size / chunkTime;
          this.uploadStats.chunksCompleted++;
          this.uploadStats.speed = chunkSpeed;

          const remainingChunks = this.totalChunks - (i + 1);
          this.uploadStats.estimatedTime = remainingChunks * (this.chunkSize / chunkSpeed);

          this.uploaded2 = Math.round(((i + 1) / this.totalChunks) * 100)
          this.lastUploadedChunk = i;

          this.speedSpan = chunkSpeed
          this.etaSpan = this.uploadStats.estimatedTime

          this.addLog(`chunk ${i + 1} آپلود شد (${this.formatFileSize(chunkSpeed)}/ثانیه)`, 'success');

        } catch (error) {
          this.addLog(`خطا در آپلود chunk ${i + 1}: ${error.message}`, 'error');
          console.error(error);
          this.uploadInProgress = false;
          break
        }
      }
      if (this.uploadInProgress) {
        const totalTime = (new Date() - this.uploadStats.startTime) / 1000;
        const averageSpeed = this.file.size / totalTime;

        this.addLog(`آپلود کامل شد! زمان: ${Math.round(totalTime)} ثانیه`, 'success');
        this.addLog(`میانگین سرعت: ${this.formatFileSize(averageSpeed)}/ثانیه`, 'success');

        this.uploaded2 = '100';
        this.speedSpan = 0;
        this.etaSpan = 0;
      }
      this.getProductMedias()
    },
    async uploadChunk(chunkNumber, totalChunks, chunkBlob, originalFileName, retryCount = 0) {
      this.isBtnsDisabled = true
      const maxRetries = 3;
      let lastTime = Date.now();
      let lastLoaded = 0;
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 120000);

        const formData = new FormData();
        formData.append('ChunkNumber', chunkNumber.toString());
        formData.append('TotalChunks', totalChunks.toString());
        formData.append('FileId', this.fileId);
        formData.append('OriginalFileName', originalFileName);
        formData.append('File', chunkBlob, originalFileName);

        const chunkConfig = {
          method: 'POST',
          data: formData,
          signal: controller.signal,
          url: Helper.baseUrl
            + 'api/ChunckedUploader/UploadChunk?productId='
            + this.productId
            + '&productType='
            + this.productType
            + '&quality=' + 1,
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': "Bearer " + this.userToken,
          },
          onUploadProgress: progressEvent => {
            const currentTime = Date.now()
            const timeElapsed = (currentTime - lastTime) / 1000
            const bytesUploaded = progressEvent.loaded - lastLoaded

            const completedChunks = chunkNumber;
            const completedBytes = completedChunks * this.chunkSize;
            const currentChunkBytes = progressEvent.loaded;

            const totalUploadedBytes = completedBytes + currentChunkBytes;
            this.uploadedBytes = Math.min(totalUploadedBytes, this.file.size);
            this.uploaded2 = Math.min((this.uploadedBytes / this.file.size) * 100, 100);

            const now = Date.now();
            const timeDiff = (now - lastTime) / 1000;
            if (timeDiff > 0.5) {
              this.speedSpan = (bytesUploaded / timeElapsed) / 1024

              const remainingBytes = this.file.size - this.uploadedBytes;
              if (this.speedSpan > 0) {
                this.etaSpan = remainingBytes / (this.speedSpan * 1024)
              }

              lastTime = currentTime
              lastLoaded = progressEvent.loaded
            }
          }
        }

        const response = await axios(chunkConfig)

        if (response.data.isSuccess) {
          clearTimeout(timeoutId);
          this.notify('success', response.data.message, { icon: 'CheckIcon' })
          this.uploaded2 = 0

          if (!res.ok) {
            if (res.status === 500 && retryCount < maxRetries) {
              this.addLog(`خطای سرور، تلاش مجدد (${retryCount + 1}/${maxRetries})...`, 'error')
              this.notify('danger', `خطای سرور، تلاش مجدد (${retryCount + 1}/${maxRetries})...`, { icon: 'CheckIcon' })
              await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
              return this.uploadChunk(chunkNumber, totalChunks, chunkBlob, originalFileName, retryCount + 1);
            }
          }
        }
      } catch (error) {
        this.uploaded2 = 0
        console.error(error);
        if (error.name === 'AbortError' && retryCount < maxRetries) {
          this.addLog(`Timeout، تلاش مجدد (${retryCount + 1}/${maxRetries})...`, 'error')
          this.notify('danger', `Timeout، تلاش مجدد (${retryCount + 1}/${maxRetries})...`, { icon: 'CheckIcon' })
          await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
          return this.uploadChunk(chunkNumber, totalChunks, chunkBlob, originalFileName, retryCount + 1);
        }
        this.addLog(`خطا در آپلود chunk ${chunkNumber}: ${error.message}`, 'error')
      } finally {
        this.isBtnsDisabled = false
      }
    },
    async getProductMedias() {
      let _this = this;
      _this.overlay = true

      let productGetProductsMediasRequest = new ProductGetProductsMediasForAdminRequest(_this);
      productGetProductsMediasRequest.setId(_this.productId)
      await productGetProductsMediasRequest.fetch(function (content) {
        _this.overlay = false;
        _this.medias = content;
      }, function (content) {
        _this.overlay = false;
      });
    },
    showModal(param) {
      this.deleteItem = param
    },
    showChangeNameModal(param1, param2) {
      this.namePictureURL = param1;
      this.newName = param2
    },
    showChangePriorityModal(param1, priority) {
      this.priorityPictureURL = param1;
      this.newPriority = priority;
    },
    select(event) {
      this.file = event.target.files.item(0);
    },
    uploadSubMedia() {
      let _this = this;
      let videos = _this.medias.videos;
      let passage = true;
      videos.find(el => {
        if (el.parentId === _this.uploadParentId && el.quality === _this.quality) {
          passage = false;
          return _this.notify(
            'danger',
            'ویدیویی با کیفیت مورد نظر شما موجود است, برای بار گذاری ویدیو جدید ابتدا باید ویدیو قبلی را حذف کنید.',
            { title: 'توجه', icon: 'CloseIcon' }
          )
        }
      })
      if (passage === true) {
        _this.overlay = true;
        axios(_this.config2).then(response => {
          if (response.data.isSuccess === false) {
            _this.notify('danger', response.data.errorMessage, { icon: 'CheckIcon' })
            _this.overlay = false;
            _this.errorAlert = true;
          } else {
            _this.notify('success', 'فایل با موفقیت آپلود شد.', { icon: 'CheckIcon' })
            _this.overlay = false;
            _this.done = true;
            _this.getProductMedias()
          }
        }).catch(error => {
          _this.overlay = false;
          _this.errorAlert = true;
          console.log(error);
        });
      }
    },
    async deleteMedia(param) {
      let _this = this;
      _this.overlay = true

      let mediaDeleteByPictureUrlRequest = new MediaDeleteByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setSocialMediaId(param);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'حذف شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    async updateMediaName() {
      let _this = this;
      _this.overlay = true

      let data = {
        socialMediaId: _this.namePictureURL,
        newName: _this.newName
      }

      let mediaChangeMediaNameRequest = new MediaChangeMediaNameRequest(_this);
      mediaChangeMediaNameRequest.setParams(data);
      await mediaChangeMediaNameRequest.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'عملیات انجام شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    setUploadParentId(id, q) {
      this.uploadParentId = id;
      this.quality = q;
    },
    async updateMediaPriority() {
      let _this = this;
      _this.overlay = true

      let data = {
        socialMediaId: _this.priorityPictureURL,
        priority: _this.newPriority
      }

      let mediaChangePriorityRequest = new MediaChangePriorityRequest(_this);
      mediaChangePriorityRequest.setParams(data);
      await mediaChangePriorityRequest.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'عملیات انجام شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    selectMediaForMediaGroup(mediaId, type) {
      this.selectedMediaIdForMediaGroup = mediaId;
      this.selectedTypeForMediaGroup = type;
    },
    selectMediaForIsReachable(mediaId, type) {
      this.selectedMediaIdForIsReachableType = mediaId;
      this.selectedIsReachableType = type;
    },
    async updateMediaGroupType() {
      let _this = this;
      _this.overlay = true

      let data = {
        mediaId: _this.selectedMediaIdForMediaGroup,
        type: _this.selectedTypeForMediaGroup
      }

      let productSetMediaGroupTypeRequest = new ProductSetMediaGroupTypeRequest(_this);
      productSetMediaGroupTypeRequest.setParams(data);
      await productSetMediaGroupTypeRequest.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'عملیات انجام شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    async arvanCreate() {
      let _this = this;
      _this.overlay = true;

      if (_this.arvanObj.title.length === 0) {
        return _this.notify('danger', 'عنوان فایل الزامی است.')
      }

      let arvanCloudVideoCreateRequest = new ArvanCloudVideoCreateRequest(_this);
      arvanCloudVideoCreateRequest.setParams(_this.arvanObj);
      await arvanCloudVideoCreateRequest.fetch(function (content) {
        _this.overlay = false
        if (content.isSuccess) {
          _this.notify('success', 'درخواست شما ارسال شد.')
        } else {
          _this.notify('danger', 'عملیات انجام نشد.')
        }
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
      })
    },
    async deleteVideoMedia() {
      let _this = this;
      _this.overlay = true

      let mediaDeleteByPictureUrlRequest = new MediaDeleteByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setSocialMediaId(_this.tempVideoObject.pictureUrl);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'حذف شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    async sendMediaRemoveRequest() {
      if (!this.tempVideoObject || !this.tempVideoObject.arvanCloudVideoId) {
        try {
          await this.deleteVideoMedia()
        } catch (error) {
          console.error(error);
        } finally {
          this.overlay = false;
        }
      } else {
        await this.sendDeleteArvanVideo();
      }
    },
    async sendDeleteArvanVideo() {
      try {
        this.overlay = true;
        let _this = this;
        let deleteArvanVideo = new DeleteArvanVideo(_this);
        deleteArvanVideo.setRequestParam({
          videoId: _this.tempVideoObject.arvanCloudVideoId,
        });
        await deleteArvanVideo.fetch((response) => {
          if (response.isSuccess) {
            _this.deleteVideoMedia();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    async setReachableMedia() {
      let _this = this;
      _this.overlay = true

      let data = {
        mediaId: _this.selectedMediaIdForIsReachableType,
        isReachable: _this.selectedIsReachableType
      }

      let productSetReachableRequest = new ProductSetReachableRequest(_this);
      productSetReachableRequest.setParams(data);
      await productSetReachableRequest.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'عملیات انجام شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    async getTestDescription() {
      let _this = this;
      _this.overlay = true

      let data = {
        productId: _this.productId,
      }

      let psychologicalTestGetByProductId = new PsychologicalTestGetByProductId(_this);
      psychologicalTestGetByProductId.setParams(data);
      await psychologicalTestGetByProductId.fetch(function (content) {
        _this.overlay = false
        _this.temptest = content.data;
        _this.testDescription = content.data.resultDescription;
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    async setTestDescription() {
      let _this = this;
      _this.overlay = true

      let data = {
        id: _this.temptest.id,
        resultDescription: _this.testDescription
      }

      let updateResultDescription = new UpdateResultDescription(_this);
      updateResultDescription.setParams(data);
      await updateResultDescription.fetch(function (content) {
        _this.overlay = false
        _this.notify('success', 'عملیات انجام شد.')
        _this.getProductMedias()
      }, function (error) {
        _this.overlay = false
        _this.notify('danger', 'عملیات انجام نشد.')
      })
    },
    setEditorContent(content) {
      this.testDescription = content;
    },
  }
}
</script>

<style scoped></style>
